{
	"ariaSetPhotoFlag": "Set Photo Flag"
}
